/* eslint-disable no-alert */
import React from 'react'
import _ from 'lodash'
import { Message, Dimmer, Loader, Header } from 'semantic-ui-react'
import firebase from 'firebase/app'

import NotificationForm from '../forms/notificationForm'

export default class DriverNotification extends React.PureComponent {
  state = {
    title: '',
    description: '',
    driverType: 'all',
    selectedDrivers: [],
    selectedDriverSegment: '',
    sending: false,
    succeedVisible: false,
    warningVisible: false,
    failedVisible: false,
  }

  onSelectDriver = driverUID => {
    const { selectedDrivers } = this.state

    if (_.includes(selectedDrivers, driverUID)) {
      this.setState({
        selectedDrivers: _.filter(selectedDrivers, driverKey => driverKey !== driverUID),
      })
    } else {
      this.setState({
        selectedDrivers: [...selectedDrivers, driverUID],
      })
    }
  }

  onSelectDriverSegment = driverSegmentId => {
    this.setState({
      selectedDriverSegment: driverSegmentId,
    })
  }

  getAllDriversPushToken = () => {
    return firebase
      .database()
      .ref(`drivers_push_token`)
      .once('value')
      .then(snapshot => snapshot.val())
  }

  getPushTokens = async driversToSend => {
    const allDriversToken = await this.getAllDriversPushToken()

    const tokens = []

    _.map(driversToSend, driverUID => {
      if (allDriversToken[driverUID] && allDriversToken[driverUID].push_token) {
        tokens.push(allDriversToken[driverUID].push_token)
      }
    })

    this.sendNotificationMessage(tokens)
  }

  sendNotificationMessage = async (tokens = []) => {
    try {
      if (tokens.length === 0) throw new Error('There are no driver notification tokens found.')

      const { title, description } = this.state
      const promises = []
      const tokenPerBatch = 100
      let sentCount = 0

      const callable = firebase
        .app()
        .functions('asia-northeast1')
        .httpsCallable('notifyDrivers')

      const batchSize = Math.ceil(tokens.length / tokenPerBatch)

      for (let i = 0; i < batchSize; i += 1) {
        const begin = i * tokenPerBatch
        const end = begin + tokenPerBatch
        const tokensBatch = tokens.slice(begin, end)

        const params = {
          tokens: tokensBatch,
          title: title.trim(),
          body: description.trim(),
        }

        promises.push(callable(params))
      }

      const allResults = await Promise.all(promises)

      allResults.forEach(result => {
        const { data } = result
        sentCount += data.response.successCount || 0
      })

      if (sentCount < tokens.length) {
        this.setState({ sending: false }, this.handleSendWarned)
      } else if (sentCount === tokens.length) {
        this.setState({ sending: false }, this.handleSendSucceed)
      } else {
        this.setState({ sending: false }, this.handleSendFailed)
      }
    } catch (error) {
      this.setState({ sending: false })
      alert(error.Message || error)
    }
  }

  sendNotificationByDriverType = () => {
    const { selectedDrivers, driverType, selectedDriverSegment } = this.state
    const { drivers } = this.props

    let driversToSend = []

    if (driverType === 'all') {
      driversToSend = _.map(drivers, driver => driver.driverUID)
    } else if (driverType === 'custom') {
      driversToSend = selectedDrivers
    } else if (driverType === 'offline') {
      _.map(drivers, driver => {
        if (!driver.online) {
          driversToSend.push(driver.driverUID)
        }
      })
    } else if (driverType === 'driverSegment') {
      const driversInSegment = _.filter(drivers, ['driver_segment', selectedDriverSegment])

      _.map(driversInSegment, driver => {
        driversToSend.push(driver.driverUID)
      })
    }

    if (driversToSend.length === 0) {
      alert('No drivers to notify.')
      return
    }

    this.setState({ sending: true }, () => {
      this.getPushTokens(driversToSend)
    })
  }

  sendNow = () => {
    const confirm = window.confirm('Are you sure you want to send the notification now?')

    if (confirm) {
      this.sendNotificationByDriverType()
    }

    return
  }

  handleSendSucceed = () => {
    this.setState({
      title: '',
      description: '',
      succeedVisible: true,
      selectedDrivers: [],
      driverType: 'all',
    })

    setTimeout(() => {
      this.setState({ succeedVisible: false })
    }, 5000)
  }

  handleSendWarned = () => {
    this.setState({
      title: '',
      description: '',
      warningVisible: true,
      selectedDrivers: [],
      driverType: 'all',
    })

    setTimeout(() => {
      this.setState({ warningVisible: false })
    }, 5000)
  }

  handleSendFailed = () => {
    this.setState({ failedVisible: true })

    setTimeout(() => {
      this.setState({ failedVisible: false })
    }, 5000)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  renderLoading = () => {
    return (
      <Dimmer active inverted>
        <Loader inverted />
      </Dimmer>
    )
  }

  renderContent = () => {
    const { drivers, driverSegments } = this.props
    const {
      title,
      sending,
      description,
      selectedDrivers,
      selectedDriverSegment,
      driverType,
      succeedVisible,
      warningVisible,
      failedVisible,
    } = this.state

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 14px',
          }}
        >
          <div style={{ display: 'flex' }}>
            <Header>Send Notification</Header>
          </div>
        </div>
        <div
          style={{
            height: '100%',
            overflow: 'auto',
            padding: '0px 14px',
          }}
          className="list-content"
        >
          <NotificationForm
            loading={sending}
            title={title}
            drivers={drivers}
            driverSegments={driverSegments}
            description={description}
            driverType={driverType}
            selectedDrivers={selectedDrivers}
            selectedDriverSegment={selectedDriverSegment}
            onFieldChange={this.onFieldChange}
            onSelectDriver={this.onSelectDriver}
            onSelectDriverSegment={this.onSelectDriverSegment}
            sendNow={this.sendNow}
          />
          <Message
            success
            hidden={!succeedVisible}
            content="Notification successfully sent to drivers!"
          />
          <Message
            warning
            hidden={!warningVisible}
            content="Notification successfully sent to drivers, but seem there are some drivers not receive the notification due permission on device."
          />
          <Message
            negative
            hidden={!failedVisible}
            content="Notification sent to drivers failed, please check the internal error."
          />
        </div>
      </div>
    )
  }

  render() {
    const { loading, drivers } = this.props

    if (loading || !drivers) {
      return this.renderLoading()
    }

    if (drivers) {
      return this.renderContent()
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/views/notification.js